import { render, staticRenderFns } from "./IconSupport.vue?vue&type=template&id=464413f7"
import script from "./IconSupport.vue?vue&type=script&lang=js"
export * from "./IconSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports